import { render, staticRenderFns } from "./Cambiopass.vue?vue&type=template&id=412bbce2"
import script from "./Cambiopass.vue?vue&type=script&lang=js"
export * from "./Cambiopass.vue?vue&type=script&lang=js"
import style0 from "./Cambiopass.vue?vue&type=style&index=0&id=412bbce2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports